var Constants = {};

Constants.STATUS = {
  UREG: 'UREG',
  REG: 'REG',
  CCL: 'CCL',
};

Constants.STATUS_NAME = {
  UREG: '未登録',
  REG: '登録済み',
  CCL: '退会済み',
};

Constants.PAYMENT_STATUS = {
  UPAY: 'UPAY',
  REG: 'REG',
  ERR: 'ERR',
  REREG: 'REREG',
  CCL: 'CCL',
};

Constants.PAYMENT_STATUS_NAME = {
  UPAY: '決済未登録',
  REG: '決済登録済み',
  ERR: '決済失敗',
  REREG: '決済再登録済み',
  CCL: '決済停止中',
};

Constants.NIMOCLE_LINKAGE_STATUS = {
  REG: 'REG',
};

Constants.GENDER = {
  MAN: '1',
  WOMAN: '2',
  OTHER: '3',
  NOTSPECIFIED: '4',
}

Constants.GENDER_NAME = {
  '1': '男性',
  '2': '女性',
  '3': 'その他',
  MAN: '男性',
  WOMAN: '女性',
  OTHER: 'その他',
  NOTSPECIFIED: '指定なし',
}

Constants.TICKET = {
  BUS: '1',
  TRAIN: '2',
  BOTH: '3',
  NONE: '4',
}

Constants.TICKET_NAME = {
  '1': 'バス',
  '2': '電車',
  '3': '両方',
  '4': '未保有',
  BUS: 'バス',
  TRAIN: '電車',
  BOTH: '両方',
  NONE: '未保有',
}

Constants.CAUSE = {
  BENEFITS: '1',
  USAGE: '2',
  NECESSARY: '3',
  SIMILAR: '4',
  OTHER: '5',
}

Constants.CAUSE_NAME = {
  '1': '魅力的特典がない',
  '2': '使い方が分からない',
  '3': '必要ではなくなった',
  '4': '他の類似サービスを利用するから',
  '5': 'その他',
  BENEFITS: '魅力的特典がない',
  USAGE: '使い方が分からない',
  NECESSARY: '必要ではなくなった',
  SIMILAR: '他の類似サービスを利用するから',
  OTHER: 'その他',
}

Constants.TICKET_TYPE = {
  FREE: '0',
  PAID: '1',
}

Constants.TICKET_TYPE_NAME = {
  '0': '無償',
  '1': '有償',
  FREE: '無償',
  PAID: '有償',
}

Constants.ACQUIRE_SETTING_TYPE = {
  DAILYONCE: '0',
  ONETIME: '1'
}

Constants.ACQUIRE_SETTING_TYPE_NAME = {
  '0': '一日一回',
  '1': '一回限り',
  DAILYONCE: '一日一回',
  ONETIME: '一回限り',
}

Constants.BONUS_TYPE = {
  POINT: '0',
  TICKET: '1',
  BOTH: '2',
}

Constants.BONUS_TYPE_NAME = {
  '0': 'ポイント',
  '1': 'クーポン',
  '2': 'ポイントとクーポン',
  POINT: 'ポイント',
  TICKET: 'クーポン',
  BOTH: 'ポイントとクーポン',
}

Constants.LOTTERY_TYPE = {
  DAILYONCE: '0',
  ONETIME: '1'
}

Constants.LOTTERY_TYPE_NAME = {
  '0': '一日一回',
  '1': '一回限り',
  DAILYONCE: '一日一回',
  ONETIME: '一回限り',
}

Constants.STAMPBONUS_TYPE = {
  POINT: '0',
  TICKET_QR: '1',
  TICKET_BUTTON: '2',
  BOTH_QR: '3',
  BOTH_BUTTON: '4',
}

Constants.STAMPBONUS_TYPE_NAME = {
  '0': 'ポイント',
  '1': 'クーポン（QR）',
  '2': 'クーポン（ボタン）',
  '3': 'ポイントとクーポン（QR）',
  '4': 'ポイントとクーポン（ボタン）',
  POINT: 'ポイント',
  TICKET_QR: 'クーポン（QR）',
  TICKET_BUTTON: 'クーポン（ボタン）',
  BOTH_QR: 'ポイントとクーポン（QR）',
  BOTH_BUTTON: 'ポイントとクーポン（ボタン）',
}

Constants.RECEIVING_TYPE = {
  TICKET_DELIVERY: '0',
  DIGITAL_TICKET_QR: '1',
  DIGITAL_TICKET_BUTTON: '2',
  POINT: '3',
}

Constants.RECEIVING_TYPE_NAME = {
  '0': '郵送チケット',
  '1': 'クーポン（QR）',
  '2': 'クーポン（ボタン）',
  '3': 'ポイント',
  TICKET_DELIVERY: '郵送チケット',
  DIGITAL_TICKET_QR: 'クーポン（QR）',
  DIGITAL_TICKET_BUTTON: 'クーポン（ボタン）',
  POINT: 'ポイント',
}

Constants.PAPER_ORDER = 'PAPER_ORDER';

Constants.SAIBAN_CLASS = {
  CUSTOMER: 'CUSTOMER',
};

Constants.RECEIPT_NUM = {
};

Constants.SHOP_ID = 1;

Constants.MEMBERSHIPPASS = "membershippass";
Constants.POINTHISTORY = "pointhistory";
Constants.COUPONLIST = "couponlist";
Constants.COUPON = "coupon";
Constants.USER = "user";
Constants.USERCHANGE = "userchange";
Constants.FREETICKETLIST = "freeticketlist";
Constants.PAIDTICKETLIST = "paidticketlist";
Constants.FREETICKETUSE = "freeticketuse";
Constants.FREETICKETISSUEUSE = "freeticketissueuse";
Constants.PAIDTICKETUSE = "paidticketuse";
Constants.PAIDTICKETISSUEUSE = "paidticketissueuse";
Constants.PAYMENT = "payment";
Constants.RANKUP = "rankup";
Constants.BENEFITUSE = "benefituse";
Constants.BENEFITGRANTUSE = "benefitgrantuse";
Constants.APPLOTTERY = "applottery";
Constants.EVENT = "event";
Constants.EVENTINFO = "eventinfo";
Constants.BENEFITFINISH = "benefitfinish";
Constants.DELIVERYBENEFITFINISH = "deliverybenefitfinish";
Constants.INPUTENTRY = "inputentry";

//店舗ユーザーに許可された画面
Constants.SHOPUSER_PAGES = [
  "login",
  "pointterminal",
  "pointhistory",
];
//施設責任者にのみ許可された画面
Constants.MANAGERMALL_PAGES = [
  "user",
  "setting",
  "mall",
  "customerrank",
];
Constants.POINTLIST = "pointlist";
Constants.ENTRY = "entry";
//Constants.COUPON = "coupon";
//Constants.USER = "user";
Constants.NOTCAMPAIGN = "notcampaign";
Constants.CAMPAIGNLIST = "campaignlist";
Constants.CAMPAIGNCLOSE = "campaignclose";
Constants.CONFIRM = "confirm";
Constants.CONFIRM2 = "confirm2";
Constants.CAMPAIGNENTRY = "campaignentry";
Constants.RECEIPTSCAN = "receiptscan";
Constants.STAMPCARD = "stampcard";
Constants.STAMPSCAN = "stampscan";
Constants.DISPLAYWAITING = "displaywaiting";
Constants.STAMPCHECK = "stampcheck";
Constants.REGISTRATIONUSER = "registrationuser";
Constants.TERMS = "terms";
Constants.FIRSTBONUS = "firstbonus";
Constants.HELP = "help";

Constants.SETTING = {
  MEMBER_AMOUNT: "MEMBER_AMOUNT",
  NOT_MEMBER_AMOUNT: "NOT_MEMBER_AMOUNT",
  FIRST_MONTH: "FIRST_MONTH",
  PAYMENT_MESSAGE: "PAYMENT_MESSAGE",
  PAYMENT_MESSAGE2: "PAYMENT_MESSAGE2",
  PAYMENT_REQUIRED: "PAYMENT_REQUIRED",
  PAYMENT_BACK: "PAYMENT_BACK",
  MODAL_NOTICE: "MODAL_NOTICE",
  MODAL_NOTICE2: "MODAL_NOTICE2",
  LOGIN_FAIL_COUNT: "LOGIN_FAIL_COUNT",
  MFA_USE: "MFA_USE",
  DAY_BEFORE_LIMIT: "DAY_BEFORE_LIMIT",
}

Constants.OPEN = "1";
Constants.CLOSE = "2";

Constants.ACTIVE_BUTTONS = {
  'REG': [
    'PRE',
    'CALL',
  ],
  'PRE': [
    'FIN',
    'ABS',
  ],
  'AABS': [
    'FIN'
  ],
  'CALL': [
    'HOLD',
    'FIN',
  ],
  'HOLD': [
    'CALL',
  ],
  'ABS': [
    'FIN'
  ],
  'CCL': [],
  'UCCL': [],
  'ACCL': [],
  'FIN': [],
};

Constants.COLOR = {
  '1': 'info',
  '2': 'success',
  BUS: 'info',
  TRAIN: 'success',
};

Constants.FLAG = {
  OFF: '0',
  ON: '1'
}

Constants.INPUT = {
  DISABLED: '0',
  ENABLED: '1',
  REQUIRED: '2'
}

Constants.RECEIVE_TIME = {
  AM: '1',
  PM12: '2',
  PM14: '3',
  PM16: '4',
}

Constants.RECEIVE_TIME_NAME = {
  '1': '午前中',
  '2': '12時～14時',
  '3': '14時～16時',
  '4': '16時～18時',
  AM: '午前中',
  PM12: '12時～14時',
  PM14: '14時～16時',
  PM16: '16時～18時',
}
Constants.CAMPAIGN_IMAGE_DIR = "images/campaign/";
Constants.COUPON_IMAGE_DIR = "images/coupon/";
Constants.COUPON_PDF_DIR = "images/coupon_pdf/";
Constants.TICKET_IMAGE_DIR = "images/ticket/";
Constants.TICKET_DETAIL_IMAGE_DIR = "images/ticket_detail/";
Constants.TICKET_PDF_DIR = "images/ticket_pdf/";
Constants.STAMP_IMAGE_DIR = "images/stamp/";
Constants.FIRST_BONUS_IMAGE_DIR = "images/firstbonus/"
Constants.BENEFIT_IMAGE_DIR = "images/benefit/";
Constants.CHECKIN_IMAGE_DIR = "images/checkin/";
Constants.LOTTERY_BEFORE_IMAGE_DIR = "images/lottery_before/";
Constants.LOTTERY_AFTER_IMAGE_DIR = "images/lottery_after/";
Constants.LOTTERY_BONUS_IMAGE_DIR = "images/lottery_bonus/";
Constants.BENEFIT_LOTTERY_TICKET_IMAGE_DIR = "images/benefit_lottery_ticket/";
Constants.BENEFIT_LOTTERY_TICKET_DETAIL_IMAGE_DIR = "images/benefit_lottery_ticket_detail/";
Constants.NOTICE_LOTTERY_IMAGE_DIR = "images/notice_lottery/";
Constants.NOTICE_RANK_IMAGE_DIR = "images/notice_rank/";

Constants.AUTH_ONLY = 2;

Constants.PRIVACYPOLICY_URL = "https://www.nishitetsu.jp/nnr/policy/";
Constants.TERMS_OF_SERVICE_URL = "https://www.nishitetsu.jp/bus/norikata/digitalcard/riyokiyaku/";
Constants.LP_URL = "https://www.nishitetsu.ne.jp/nis/";

Constants.JOB_CD_NAME = {
  AUTH: '仮売上',
  SALES: '実売上',
  PEND: '保留',
  ERR: 'エラー',
  VOID: '取消',
}

Constants.USER_CLASS = {
  MANAGER: '1',
  STAFF: '2',
  MANAGERMALL: '3',
}

Constants.USER_CLASS_NAME = {
  '1': '施設管理者',
  '2': '店舗ユーザ',
  '3': '施設責任者',
  MANAGER: '施設管理者',
  STAFF: '店舗ユーザ',
  MANAGERMALL: '施設責任者',
};

Constants.CAMPAIGN_IMAGE_LIST = {
  CONFIRM_TITLE: 'confirm_title.png',
  POINTCARD: 'pointcard.png',
  POINTENTRY: 'point10.png',
  ENTRYCOMMENT: 'entry_comment.png',
  CAMPAIGNEND: 'campaign_end.png'
}

Constants.CAMPAIGN_IMAGE_LIST_NAME = {
  CONFIRM_TITLE: 'キャンペーン詳細表示タイトル',
  POINTCARD: 'ポイントカード表示画像',
  ENTRYCOMMENT: 'キャンペーン参加表示画像',
  CAMPAIGNEND: 'キャンペーン終了表示画像'
}

Constants.PUSH_STATUS = {
  NOT: '0',
  SEND: '1'
}

Constants.CAMPAIGN_MESSAGE = {
  ENTRY_MESSAGE_1: "レスキュー達成！",
  ENTRY_MESSAGE_2: "本キャンペーンは何口でも応募可能です。\nひきつづき「フードロス削減」にご協力をお願いいたします。",
  END_MESSAGE_1: "「フードロス削減」にご協力いただき、ありがとうございました。\n※当選者の発表は、商品の発送をもってかえさせていただきます。",
  END_MESSAGE_2: "今後とも、「フードロス削減」にご協力をお願いいたします。",
}

Constants.POINT_SCREEN = {
  MAIN: 1,
  CAMERA: 2,
  DETAIL: 3,
}

Constants.INVALID_CAUSE = {
  RETURNED: '1',
  OTHER: '9',
  SAKULALA: '2',
}

Constants.INVALID_CAUSE_NAME = {
  '1': '返品',
  '2': 'SAKULaLa取消',
  '9': 'その他',
  RETURNED: '返品',
  SAKULALA: 'SAKULaLa取消',
  OTHER: 'その他',
}

Constants.BENEFIT_STATUS = {
  NOTSENT: 'NOTSENT',
  SENT: 'SENT',
  NOTUSED: 'NOTUSED',
  USED: 'USED',
}

Constants.BENEFIT_STATUS_NAME = {
  NOTSENT: '未送付',
  SENT: '送付済み',
  NOTUSED: '未使用',
  USED: '使用済み',
}

Constants.INVALID_FLAG = {
  UNCONFIRM: null,
  VALID: '0',
  INVALID: '1',
}

Constants.INVALID_FLAG_NAME = {
  '0': '有効',
  '1': '無効',
  UNCONFIRM: '未確認',
  VALID: '有効',
  INVALID: '無効',
}

Constants.PAYMENT_METHOD = {
  CASH: '1',
  CARD: '2',
  ELECTRONICMONEY: '3',
  QR: '4',
  SAKULALA: '5'
}
Constants.PAYMENT_METHOD_NAME = {
  '0': '指定なし',
  '1': '現金・商品券',
  '2': 'クレジット',
  '3': '電子マネー',
  '4': 'QR',
  '5': 'SAKULaLa決済',
  CASH: '現金・商品券',
  CARD: 'クレジット',
  ELECTRONICMONEY: '電子マネー',
  QR: 'QR',
  SAKULALA: 'SAKULaLa決済',
}
Constants.POINT_TYPE = {
  NORMAL: '0',//通常
  FIRST: '1',//初回特典
  CAMPAIGN: '2',//キャンペーン
  BONUS: '3',//ボーナスポイント
  RANKUP: '4',//ランクアップボーナス
  LOTTERY: '5',//抽選
  CHECKIN: '6',//チェックイン
  STAMPBONUS: '7',//スタンプボーナス
  SHORTAGE: '9',//不足補填
  MINUSPOINT: '10',//マイナスポイント
  LOTTERYTICKET: '11',//抽選券ポイント
  CHECKINCAMPAIGN: '12',//チェックイン(キャンペーン)
  NIMOCLE: '13',//西鉄ショッピングポイント(nimocle)
}
Constants.POINT_TYPE_NAME = {
  '0': '通常ポイント',
  '1': '初回特典',
  '2': 'キャンペーン',
  '3': 'ボーナスポイント',
  '4': 'ランクアップボーナス',
  '5': '抽選ポイント',
  '6': 'チェックインポイント',
  '7': 'スタンプボーナス',
  '9': '不足補填',
  '10': 'マイナスポイント',
  '11': '抽選券ポイント',
  '12': 'キャンペーン(チェックイン)',
  '13': 'nimocleボーナスポイント',
  NORMAL: '通常',
  FIRST: '初回特典',
  CAMPAIGN: 'キャンペーン',
  BONUS: 'ボーナスポイント',
  RANKUP: 'ランクアップボーナス',
  LOTTERY: '抽選ポイント',
  CHECKIN: 'チェックインポイント',
  STAMPBONUS: 'スタンプボーナス',
  SHORTAGE: '不足補填',
  MINUSPOINT: 'マイナスポイント',
  LOTTERYTICKET: '抽選券ポイント',
  CHECKINCAMPAIGN: 'キャンペーン(チェックイン)',
}

Constants.RETURNS_TYPE = {
  POINT: '1',
  TICKET: '2',
}

Constants.RETURNS_TYPE_NAME = {
  '1': 'ポイント付与取消',
  '2': 'ポイント利用取消',
  POINT: 'ポイント付与取消',
  TICKET: 'ポイント利用取消',
}

Constants.BENEFIT_LOTTERY_TICKET_STATUS = {
  ISSUED: 'ISSUED',        // 発行済み（未使用・未応募）
  APPLIED: 'APPLIED',       // 応募済み（申し込み済み）
  WIN: 'WIN',           // 当選
  LOSE: 'LOSE',          // 落選
  USED: 'USED',          // 使用済み（引き換え済み）
  EXPIRED: 'EXPIRED',       // 期限切れ
  CANCELED: 'CANCELED',     // キャンセル
  SENT: 'SENT', // 当選通知済み（当選者に当選通知を送った状態）
  DELIVERY: 'DELIVERY', // 当選通知済み（当選者に当選通知を送った状態）
};

Constants.BENEFIT_LOTTERY_TICKET_STATUS_NAME = {
  ISSUED: '発行済み（未使用・未応募）',
  APPLIED: '応募済み',
  WIN: '当選',
  LOSE: '落選',
  USED: '使用済み',
  EXPIRED: '期限切れ',
  CANCELED: 'キャンセル',
  SENT: '当選通知済み',
  DELIVERY: '配送済み',
};

Constants.SCHEDULE_TYPE = {
  WEEKDAY: '0',
  DATE: '1',
}

Constants.WEEKDAY = {
  '0': '日曜日',
  '1': '月曜日',
  '2': '火曜日',
  '3': '水曜日',
  '4': '木曜日',
  '5': '金曜日',
  '6': '土曜日',
}

export default Constants;